/* PSI product page — revamp Wave 2 (22 Oct 2026).
 *  1. Delivery promise dates (IST, business days Mon–Sat).
 *  2. WhatsApp links with a pre-filled message naming this product.
 *  3. "Design preview" note shown only once the personalisation form exists.
 *  4. Event-date placeholder shortened (it was cut off on phones).
 *  5. Sticky Add-to-cart bar: shown whenever the main button is off screen; on
 *     personalised products it never adds on its own — it takes the shopper to the
 *     first empty required field, or presses the main Add to cart (same validation,
 *     same personalisation properties, same lead/prefill hooks as a normal tap).
 * Everything is wrapped so a failure here can never block buying.
 */
(function () {
  'use strict';
  if (window.__psiPdp) return; window.__psiPdp = true;
  var CFG = window.PSI_PDP || {};
  var WA = CFG.wa || '919841131131';
  var HOLIDAYS = CFG.holidays || [];          // ['2026-11-08', ...] — no dispatch / delivery on these
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[psi-pdp]', e && e.message); } }

  /* ---------- 1. delivery dates ---------- */
  function istToday() {
    var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, 12));
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function addBusinessDays(d, n) {
    d = new Date(d.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (d.getUTCDay() !== 0 && HOLIDAYS.indexOf(iso(d)) === -1) n--; }
    return d;
  }
  function fmt(d) {
    return new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(d);
  }
  safe(function () {
    var ship = addBusinessDays(istToday(), CFG.shipDays || 1);
    document.querySelectorAll('[data-psi-dp-ship]').forEach(function (el) { el.textContent = fmt(ship); });
    document.querySelectorAll('[data-psi-dp-ship-wrap]').forEach(function (el) { el.hidden = false; });
  });

  /* ---------- 2. WhatsApp links ---------- */
  safe(function () {
    var title = (document.querySelector('product-info h1') || {}).textContent || document.title;
    title = title.replace(/\s+/g, ' ').trim();
    var url = location.origin + location.pathname;
    var msgs = {
      preview: 'Hi Party Supplies India! I would like to see a design preview first for: ' + title + ' ' + url,
      urgent: 'Hi Party Supplies India! My party is soon. What is the fastest delivery for: ' + title + ' ' + url
    };
    document.querySelectorAll('[data-psi-wa]').forEach(function (a) {
      var m = msgs[a.getAttribute('data-psi-wa')];
      if (m) a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(m);
    });
  });

  /* ---------- 3 + 4. personalisation form helpers (Infinite Options renders late) ---------- */
  var PLACEHOLDER_RX = /for shipping purposes only/i;
  function tidyIO() {
    var box = document.getElementById('infiniteoptions-container');
    if (!box) return false;
    var fields = box.querySelectorAll('input, textarea, select');
    if (!fields.length) return false;
    fields.forEach(function (f) {
      if (f.placeholder && PLACEHOLDER_RX.test(f.placeholder)) {
        f.placeholder = 'Used for delivery planning only';
        f.setAttribute('aria-description', 'For shipping purposes only. Not printed on the product.');
      }
    });
    document.querySelectorAll('[data-psi-pv]').forEach(function (el) { el.hidden = false; });
    return true;
  }
  safe(function () {
    if (tidyIO()) return;
    var tries = 0;
    var t = setInterval(function () { tries++; safe(function () { if (tidyIO() || tries > 40) clearInterval(t); }); }, 500);
  });

  /* ---------- 5. sticky Add to cart ---------- */
  safe(function () {
    var info = document.querySelector('product-info');
    var sticky = info && info.querySelector('animate-sticky');
    if (!sticky) return;
    function findMain() {
      // The main product form (skips the sticky "--alt" form and the hidden installments form).
      var forms = info.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i], fid = f.getAttribute('id') || '';   // not f.id: an <input name="id"> shadows it
        if (/--alt$/.test(fid) || /installment/i.test(fid) || f.closest('animate-sticky')) continue;
        var btn = f.querySelector('[name="add"]') || (fid && document.querySelector('[form="' + fid + '"][name="add"]'));
        if (btn) return { form: f, id: fid, btn: btn };
      }
      return null;
    }
    if (!findMain()) return;

    // Take over when the bar shows: whenever the main button is off screen.
    // (Re-queried every time: the theme can re-render the buy buttons on variant change.)
    if (sticky.onScrollHandler) window.removeEventListener('scroll', sticky.onScrollHandler);
    var ticking = false;
    function update() {
      ticking = false;
      var m = findMain(); if (!m) return;
      var r = m.btn.getBoundingClientRect();
      var onScreen = r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
      if (onScreen) sticky.removeAttribute('animate'); else sticky.setAttribute('animate', '');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update(); setTimeout(update, 1500);

    function requiredFields(id) {
      var out = [];
      if (!id) return out;
      document.querySelectorAll('[required]').forEach(function (f) {
        var host = f.closest('form');
        if (f.getAttribute('form') === id || (host && host.getAttribute('id') === id)) out.push(f);
      });
      return out;
    }
    function isEmpty(f) {
      if (f.type === 'checkbox' || f.type === 'radio') {
        return !Array.prototype.some.call(document.querySelectorAll('input[name="' + (window.CSS && CSS.escape ? CSS.escape(f.name) : f.name) + '"]'), function (i) { return i.checked; });
      }
      return String(f.value || '').trim() === '';
    }
    var hint = null, hintTimer = null;
    function showHint(btn, text) {
      var host = sticky.querySelector('.product-sticky-cart') || btn.parentElement; if (!host) return;   // full-width fixed bar
      if (!hint) { hint = document.createElement('div'); hint.className = 'psi-sticky-hint'; hint.setAttribute('role', 'status'); }
      hint.textContent = text; host.appendChild(hint);
      requestAnimationFrame(function () { hint.classList.add('is-on'); });
      clearTimeout(hintTimer); hintTimer = setTimeout(function () { hint.classList.remove('is-on'); }, 2600);
    }

    window.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('animate-sticky [name="add"], animate-sticky [type="submit"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var m = findMain(); if (!m) return;
      var mainForm = m.form, mainBtn = m.btn;
      var req = requiredFields(m.id);
      if (!req.length) return;                     // plain product: the theme's sticky add works as is
      ev.preventDefault(); ev.stopImmediatePropagation();
      var empty = req.filter(function (f) { return isEmpty(f) && f.offsetParent !== null; })[0] ||
                  req.filter(isEmpty)[0];
      if (empty) {
        showHint(btn, 'Add your personalisation details first ↑');
        var target = empty.closest('.form-field, .option-wrapper, div') || empty;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          try { empty.focus({ preventScroll: true }); } catch (e) { empty.focus(); }
          empty.classList.add('psi-field-flash');
          setTimeout(function () { empty.classList.remove('psi-field-flash'); }, 2200);
        }, 450);
        return;
      }
      // All details filled: copy the sticky quantity across, then press the real button.
      var sq = sticky.querySelector('input[name="quantity"]');
      var mq = document.querySelector('input[name="quantity"][form="' + m.id + '"]') || mainForm.querySelector('input[name="quantity"]');
      if (sq && mq && sq.offsetParent !== null && sq.value && sq.value !== mq.value) {
        mq.value = sq.value; mq.dispatchEvent(new Event('change', { bubbles: true }));
      }
      mainBtn.click();
    }, true);
  });
})();
